/**
 * Endet die Antwort mit einer Frage? (Ticket 2403, 2522)
 *
 * Seit Welle 1 (jev-plan) liegt die Regel an EINER Stelle: shared/frage-am-ende.ts
 * (dort steht auch die Begründung der Grenze und der Nachsatz-Toleranz). Diese Datei
 * bleibt als Import-Pfad der App.
 */
export { endetMitFrage, letzterSatz, letzterAbsatz, wartetAmEnde } from "../../shared/frage-am-ende.js";
